"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEASER_EVOLUTION_TYPE = exports.TEASER_EVOLUTION_STYLE_TYPE = exports.TEASER_EVOLUTION_LOGO_POSITION_TYPE = exports.TEASER_EVOLUTION_IMAGE_POSITION_TYPE = exports.TEASER_EVOLUTION_CONTENT_POSITION_TYPE = exports.SmallTeaser = exports.STYLES_WITH_BACKGROUND_BANNER = void 0;
var _react = _interopRequireDefault(require("react"));
require("./SmallTeaser.scss");
let TEASER_EVOLUTION_TYPE = exports.TEASER_EVOLUTION_TYPE = /*#__PURE__*/function (TEASER_EVOLUTION_TYPE) {
  TEASER_EVOLUTION_TYPE["banner"] = "banner";
  TEASER_EVOLUTION_TYPE["size100"] = "size100";
  TEASER_EVOLUTION_TYPE["size66"] = "size66";
  TEASER_EVOLUTION_TYPE["size50"] = "size50";
  TEASER_EVOLUTION_TYPE["size33"] = "size33";
  return TEASER_EVOLUTION_TYPE;
}({});
let TEASER_EVOLUTION_STYLE_TYPE = exports.TEASER_EVOLUTION_STYLE_TYPE = /*#__PURE__*/function (TEASER_EVOLUTION_STYLE_TYPE) {
  TEASER_EVOLUTION_STYLE_TYPE["light"] = "light";
  TEASER_EVOLUTION_STYLE_TYPE["dark"] = "dark";
  TEASER_EVOLUTION_STYLE_TYPE["DMKGreen"] = "DMK-Green";
  TEASER_EVOLUTION_STYLE_TYPE["DMKBlue"] = "DMK-Blue";
  TEASER_EVOLUTION_STYLE_TYPE["DMKGreyBlue"] = "DMK-GreyBlue";
  TEASER_EVOLUTION_STYLE_TYPE["DMKWarmGrey"] = "DMK-WarmGrey";
  TEASER_EVOLUTION_STYLE_TYPE["DMKYellow"] = "DMK-Yellow";
  TEASER_EVOLUTION_STYLE_TYPE["DMKRose"] = "DMK-Rose";
  TEASER_EVOLUTION_STYLE_TYPE["DMKRed"] = "DMK-Red";
  TEASER_EVOLUTION_STYLE_TYPE["DMKViolet"] = "DMK-Violet";
  TEASER_EVOLUTION_STYLE_TYPE["DMKPetrol"] = "DMK-Petrol";
  return TEASER_EVOLUTION_STYLE_TYPE;
}({});
let TEASER_EVOLUTION_CONTENT_POSITION_TYPE = exports.TEASER_EVOLUTION_CONTENT_POSITION_TYPE = /*#__PURE__*/function (TEASER_EVOLUTION_CONTENT_POSITION_TYPE) {
  TEASER_EVOLUTION_CONTENT_POSITION_TYPE["left"] = "left";
  TEASER_EVOLUTION_CONTENT_POSITION_TYPE["right"] = "right";
  return TEASER_EVOLUTION_CONTENT_POSITION_TYPE;
}({});
let TEASER_EVOLUTION_LOGO_POSITION_TYPE = exports.TEASER_EVOLUTION_LOGO_POSITION_TYPE = /*#__PURE__*/function (TEASER_EVOLUTION_LOGO_POSITION_TYPE) {
  TEASER_EVOLUTION_LOGO_POSITION_TYPE["bottom"] = "bottom";
  TEASER_EVOLUTION_LOGO_POSITION_TYPE["top"] = "top";
  return TEASER_EVOLUTION_LOGO_POSITION_TYPE;
}({});
let TEASER_EVOLUTION_IMAGE_POSITION_TYPE = exports.TEASER_EVOLUTION_IMAGE_POSITION_TYPE = /*#__PURE__*/function (TEASER_EVOLUTION_IMAGE_POSITION_TYPE) {
  TEASER_EVOLUTION_IMAGE_POSITION_TYPE["center"] = "center";
  TEASER_EVOLUTION_IMAGE_POSITION_TYPE["left"] = "left";
  TEASER_EVOLUTION_IMAGE_POSITION_TYPE["right"] = "right";
  return TEASER_EVOLUTION_IMAGE_POSITION_TYPE;
}({});
const STYLES_WITH_BACKGROUND_BANNER = exports.STYLES_WITH_BACKGROUND_BANNER = [TEASER_EVOLUTION_STYLE_TYPE.DMKGreen, TEASER_EVOLUTION_STYLE_TYPE.DMKBlue, TEASER_EVOLUTION_STYLE_TYPE.DMKGreyBlue, TEASER_EVOLUTION_STYLE_TYPE.DMKWarmGrey, TEASER_EVOLUTION_STYLE_TYPE.DMKYellow, TEASER_EVOLUTION_STYLE_TYPE.DMKRose, TEASER_EVOLUTION_STYLE_TYPE.DMKRed, TEASER_EVOLUTION_STYLE_TYPE.DMKViolet, TEASER_EVOLUTION_STYLE_TYPE.DMKPetrol];
const SmallTeaser = _ref => {
  let {
    buttonLabel,
    content,
    imageUrl,
    logoUrl,
    onClick,
    title,
    url,
    imageClassName
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-SmallTeaser"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: imageClassName,
    style: {
      backgroundImage: `url(${imageUrl})`
    }
  }), logoUrl && /*#__PURE__*/_react.default.createElement("img", {
    alt: title,
    className: "cds-Teaser-Logo",
    src: logoUrl
  }), (title || content || buttonLabel && url) && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-SmallTeaser-Content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-SmallTeaser-ContentInner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-SmallTeaser-ContentWrapper"
  }, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "cds-SmallTeaser-Title"
  }, title), content && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-SmallTeaser-Text"
  }, content)))));
};
exports.SmallTeaser = SmallTeaser;
//# sourceMappingURL=SmallTeaser.js.map